export default __webpack_public_path__ + "static/media/playstore.1da86949.svg";